import React from 'react';
import { styles } from './CouponModal.css';
import { LoadingSkeleton } from '../LoadingSkeleton/LoadingSkeleton';
import { Barcode } from '../Barcode';
import { AddToWalletUrls } from './CouponModal';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { WalletButton } from '../Account/JBWallet/WalletButton';
import { getErrorMessage } from './utils';

type BarcodeContainerProps = {
  couponCode: string;
  barcode?: string;
  barcodeLabel?: string;
  additonalInstructions?: JSX.Element;
  setIsQrModalOpen: (isOpen: boolean) => void;
  setClickedWallet: (wallet: 'apple' | 'google' | null) => void;
  addToWalletUrls?: AddToWalletUrls;
  addToWalletErrorCode?: number;
  shouldShowAddToWalletButtons?: boolean;
};

export const BarcodeContainer = ({
  couponCode,
  barcode,
  barcodeLabel,
  additonalInstructions,
  setIsQrModalOpen,
  addToWalletUrls,
  addToWalletErrorCode,
  setClickedWallet,
  shouldShowAddToWalletButtons,
}: BarcodeContainerProps) => {
  return barcode ? (
    <div className={styles.barcodeContainer}>
      <h5 className={styles.barcodeLabel}>{barcodeLabel || 'Redeem in-store'}</h5>
      {shouldShowAddToWalletButtons ? (
        <>
          {addToWalletErrorCode ? (
            <div className={styles.alertContainer}>
              <Alert type="error" heading={getErrorMessage(addToWalletErrorCode)} noMargin />
            </div>
          ) : (
            <div className={styles.addToWalletContainer}>
              <WalletButton
                setIsQrModalOpen={setIsQrModalOpen}
                setClickedWallet={setClickedWallet}
                addToWalletUrls={addToWalletUrls}
                cardType="coupon"
                location="modal"
              />
            </div>
          )}
        </>
      ) : null}
      <div className={styles.barcodeInstructions}>
        {additonalInstructions || 'Show the barcode to our staff at the counter.'}
      </div>
      <div className={styles.barcodeImageContainer}>
        <Barcode barcodeBase64={barcode} />
        <h4 className={styles.barcodeText}>{couponCode}</h4>
      </div>
    </div>
  ) : (
    <LoadingSkeleton.Image
      className={styles.loadingSkeleton}
      border="none"
      aspectRatio={2}
      shouldShimmer={true}
      width="50%"
    />
  );
};
